module.exports = __webpack_public_path__ + "media/receive_msg.3830e22f.wav";